import { Flex, useColorModeValue } from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';
import { Finding_Resolution_Types_Enum } from '@main/graphql/types.generated';

export const FindingCard = ({
  children,
  resolutionType,
}: {
  children: React.ReactNode;
  resolutionType: Finding_Resolution_Types_Enum | undefined;
}) => {
  const findingBorderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Flex
      data-testid="finding-card"
      role="group"
      p={4}
      rounded="md"
      border="1px"
      borderColor={findingBorderColor}
      opacity={resolutionType ? 0.7 : 1}
      position="relative"
      gap={4}
      direction="column"
      width="full"
    >
      {children}
    </Flex>
  );
};

const CardHeader = ({
  heading,
  subheading,
  children,
}: {
  heading: React.ReactNode;
  subheading?: React.ReactNode;
  children: React.ReactNode;
}) => {
  return (
    <Flex gap={3}>
      <Text size="xs" weight="semibold">
        {heading}
      </Text>
      {subheading && (
        <Text size="xs" color="muted">
          {subheading}
        </Text>
      )}
      {children}
    </Flex>
  );
};

const CardBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex gap={3} direction="column" width="full">
      {children}
    </Flex>
  );
};

const CardActions = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex gap={2} position="absolute" right={4} top={4}>
      {children}
    </Flex>
  );
};

FindingCard.Header = CardHeader;
FindingCard.Body = CardBody;
FindingCard.Actions = CardActions;
